module.exports = __webpack_public_path__ + "img/L1070080.ace0455b.jpg";